import imageApi from '@umu/umu-image-handle';
import { reportError } from 'common/src/services/errorLogger';

export const supportsNativeLazy = 'loading' in HTMLImageElement.prototype;

function isWebpSupported() {
    try {
        const canvas = document.createElement('canvas');
        if (canvas.getContext && canvas.getContext('2d')) {
            return canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0;
        }
    } catch (e) {
        reportError({
            error: e,
            componentName: 'isWebpSupported',
        });
    }
    return false;
}
export const isSupportedWebp = isWebpSupported();

/**
 * 判断图片 URL 的原始格式是否为 webp
 */
export const isWebpUrl = (url: string): boolean => {
    if (!url) return false;
    try {
        const pathname = new URL(url).pathname;
        return pathname.toLowerCase().endsWith('.webp');
    } catch {
        return url.split('?')[0].toLowerCase().endsWith('.webp');
    }
};

export const formatImgUrl = (url: string, width?: number) => {
    url = width ? imageApi.appendWidth(url, width) : url;
    if (isSupportedWebp && imageApi.isFromCDN(url) && !isWebpUrl(url)) {
        url = imageApi.convertFormat(url, 'webp');
    }
    return url;
};

/**
 * 移除URL中的所有查询参数
 */
export const removeAllUrlParams = (url: string): string => {
    if (!url) return url;

    const questionMarkIndex = url.indexOf('?');
    if (questionMarkIndex !== -1) {
        return url.substring(0, questionMarkIndex);
    }

    return url;
};

/**
 * 检查URL是否包含查询参数
 */
export const hasUrlParams = (url: string): boolean => {
    if (!url) return false;
    return url.includes('?');
};
